export default {backgroundColor: 'red', height: 40, padding: 10}
